/**
 * Store TVA Statuts
 */
export default {
    state: {
        tvaStatuts: [],
        statutAFaire: 1,
        statutATeletransmettre: 3,
        statutTeletransmis: 4,
    },

    mutations: {
        /**
         * Initialise le state tvaStatuts
         */
        setTvaStatuts: function (state, tvaStatuts) {
            state.tvaStatuts = tvaStatuts
        }
    },

    getters: {
        /**
         * Liste d'options de statuts de tva
         */
        optionsTvaStatuts: state => {
            return state.tvaStatuts.map(statut => {
                return {label: statut.nom, value: statut.id}
            })
        }
    }
}
